import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './21-hackathon-tips.mp3';

const transcript = `
  Hmmm, ik ben nogal veel aan het woord.  
  Ik stel voor dat jij deze slide over praktische tips doet, Jonathan.
`;

// Jonathan neemt over met praktische informatie

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1>Praktische Tips</h1>
        <div className="text-left space-y-4">
          <ul className="list-disc list-inside space-y-2">
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 4000,
                duration: 800,
              }}
            >
              <li>ChatGPT accounts voor alle deelnemers</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 4500,
                duration: 800,
              }}
            >
              <li>Speciale hackathon GPT</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 5000,
                duration: 800,
              }}
            >
              <li>Vraag de coaches van vlees en bloed</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 5500,
                duration: 800,
              }}
            >
              <li>Design Thinking aanpak:</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 6000,
                duration: 800,
              }}
            >
              <li className="ml-6">Empathize - Inleven in eindgebruikers (MAP)</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 6500,
                duration: 800,
              }}
            >
              <li className="ml-6">Define - Probleem helder krijgen</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 7000,
                duration: 800,
              }}
            >
              <li className="ml-6">Ideate - Brainstorm & schetsen</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 7500,
                duration: 800,
              }}
            >
              <li className="ml-6">Prototype - Eerste versie maken</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'slide-up',
                delay: 8000,
                duration: 800,
              }}
            >
              <li className="ml-6">Test - Presenteren en feedback</li>
            </WebContent>
          </ul>
        </div>
      </div>
    </Slide>
  );
};
